import { render } from "./uiHeading.vue?vue&type=template&id=61e553e2"
import script from "./uiHeading.vue?vue&type=script&lang=js"
export * from "./uiHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__